import { useParams } from 'react-router';
import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { CustomerDetail } from '@/components/features/organizations';

export function CustomerDetailPage() {
  const { organizationId } = useParams<{ organizationId: string }>();

  return (
    <>
      <Meta title="Customer" />

      <Container>
        <CustomerDetail organizationId={organizationId ?? ''} />
      </Container>
    </>
  );
}
